import { PageWithScene } from "@/components/PageWithScene/PageWithScene";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: Page,
});

function Page() {
  return <PageWithScene heading="Alice & Bob" scene="Alice-Bob" />;
}
